// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-inner {
    position: relative;
}

.main-container {
    margin: 0 auto;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.main-content {
    width: 80%;
    text-align: justify;
    margin: 0 auto;;
}

ul {
    list-style-type: none; /* Вимкнути стандартну символіку списку */
}
  
.grand_list_item::before {
    content: "–"; 
    margin-right: 5px; 
}


/* Start - Home page */
.mainPage-logo__container {
    height: 120px;
}

.mainPage-logo__container img {
    height: 100%;
}

.mainPage-logoPartners__container{
    /* margin-top: 100px; */
    /* margin-bottom: 100px; */
    display: flex;
    justify-content: space-between;
}

.mainPage-logoPartners__container-img {
    margin: auto 0;
}

.mainPage-logoPartners__img {
    width: 100px;
    height: auto;
    object-fit: contain;
}

@media (max-width: 1220px) {
    .mainPage-logoPartners__img {
        width: 90px;
        height: auto;
    }
}
@media (max-width: 1100px) {
    .mainPage-logoPartners__img {
        width: 80px;
    }
}

@media (max-width: 992px) {
    .mainPage-logo__container {
        height: 100px;
        margin: auto;
        /* height: auto; */
    }
    .mainPage-logoPartners__img {
        width: 120px;
    }
}

@media (max-width: 830px) {
    .mainPage-logo__container {
        height: 90px;
    }
}
@media (max-width: 767px) {
    .mainPage-logo__container {
        text-align: center;
        margin-top: 1rem;
        margin-bottom: 2rem;
    }
}

@media (max-width: 576px) {
    .mainPage-logoPartners__img {
        width: 90px;
    }
}

@media (max-width: 350px) {
    .mainPage-logoPartners__img {
        width: 80px;
    }
}

/* Start - MainCard */

.mainCard-container {
    display: flex;
    /* flex-wrap: wrap; */
    /* justify-content: space-between; */
}

.mainCard-card {
    padding: 0 40px;
}

.mainCard-card__container {
    --bs-card-border-color: none;
    --bs-card-border-radius: 0;

    min-height: 350px;
    display: flex;
}

.mainCard-card__img{
    border-radius: 0;
    text-align: justify;
}

.mainCard-card__text {
    text-align: justify;
    margin-bottom: 16px;
}

.mainCard-card__link {
    margin-top: auto;
    color: #000;
    text-decoration: none;
    cursor: default;
}

.mainCard-card__messege-container {
    position: absolute;
    /* top: 26%; */
    top: 34%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 1;
    line-height: 24px;
    padding: 20px;
    background-color: #fff;
    border-radius: 10px;
    font-size: 20px;
}

.mainCard-card__opacity {
    opacity: 0.4;
}

.mainCard-card__link {
    text-transform: upperCase;
    /* color: #2bd191be; */
    color: var(--main-green-color);
    text-decoration: underline;
}

.mainCard-card__link:hover {
    cursor: pointer;
    color: #0a58ca;
}

.mainCard-card__link:active {
    color: #0a58ca;
}


/* End - MainCard */

.button_img{
    width: 5rem;
    cursor: pointer;
    right: 10rem; 
    position: absolute;
    /* right: -80px; */
    bottom: -40px;
    transition: all 0.3s;
}

.button_img.active {
    bottom: 80px;
}

@media (max-width: 1370px) { 
    .button_img {
        right: 0;
    }
}

@media (max-width: 1190px) {
    .mainCard-card__messege-container {
        /* top: 20%; */
        top: 30%;
        line-height: 20px;
        padding: 15px;
        background-color: #fff;
        border-radius: 10px;
        font-size: 16px;
    }
}

@media (max-width: 992px) {
    .mainCard-card__messege-container {
        /* top: 15%; */
        top: 25%;
        width: 70%;
        line-height: 16px;
        padding: 10px;
        font-size: 14px;
    }
}

@media (max-width: 767px) {
    .main-content{
        width: 95%;
        padding-bottom: 55px;
    }

    .mainCard-card__container {
        min-height: 100px;
    }

    .mainCard-card__messege-container {
        /* top: 26%; */
        top: 35%;
        width: 60%;
        line-height: 24px;
        padding: 20px;
        font-size: 20px;
    }

    .button_img{
        right: 50%;
        transform: translateX(50%);
        /* bottom: -60px; */
    }

    .button_img.active {
        bottom: 40px;
    }
}

@media (max-width: 600px) {
    .mainCard-card__messege-container {
        top: 26%;
        left: 50%;
    }
}

@media (max-width: 576px) {
    .mainCard-card__messege-container {
        /* top: 60px; */
        top: 90px;
        /* top: 25%; */
        width: 80%;
        line-height: 16px;
        padding: 10px;
        font-size: 14px;
    }
}

@media (max-width: 400px) {
    .mainCard-card__messege-container {
        top: 65px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB,EAAE,yCAAyC;AACpE;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;;AAGA,sBAAsB;AACtB;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ;AACA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,aAAa;QACb,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA,qBAAqB;;AAErB;IACI,aAAa;IACb,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,0BAA0B;;IAE1B,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;;AAGA,mBAAmB;;AAEnB;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,cAAc;QACd,QAAQ;QACR,iBAAiB;QACjB,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,QAAQ;QACR,UAAU;QACV,iBAAiB;QACjB,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,QAAQ;QACR,UAAU;QACV,iBAAiB;QACjB,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,0BAA0B;QAC1B,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,SAAS;IACb;AACJ;;AAEA;IACI;QACI,eAAe;QACf,SAAS;QACT,cAAc;QACd,UAAU;QACV,iBAAiB;QACjB,aAAa;QACb,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ","sourcesContent":[".main-inner {\n    position: relative;\n}\n\n.main-container {\n    margin: 0 auto;\n    max-width: 1200px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.main-content {\n    width: 80%;\n    text-align: justify;\n    margin: 0 auto;;\n}\n\nul {\n    list-style-type: none; /* Вимкнути стандартну символіку списку */\n}\n  \n.grand_list_item::before {\n    content: \"–\"; \n    margin-right: 5px; \n}\n\n\n/* Start - Home page */\n.mainPage-logo__container {\n    height: 120px;\n}\n\n.mainPage-logo__container img {\n    height: 100%;\n}\n\n.mainPage-logoPartners__container{\n    /* margin-top: 100px; */\n    /* margin-bottom: 100px; */\n    display: flex;\n    justify-content: space-between;\n}\n\n.mainPage-logoPartners__container-img {\n    margin: auto 0;\n}\n\n.mainPage-logoPartners__img {\n    width: 100px;\n    height: auto;\n    object-fit: contain;\n}\n\n@media (max-width: 1220px) {\n    .mainPage-logoPartners__img {\n        width: 90px;\n        height: auto;\n    }\n}\n@media (max-width: 1100px) {\n    .mainPage-logoPartners__img {\n        width: 80px;\n    }\n}\n\n@media (max-width: 992px) {\n    .mainPage-logo__container {\n        height: 100px;\n        margin: auto;\n        /* height: auto; */\n    }\n    .mainPage-logoPartners__img {\n        width: 120px;\n    }\n}\n\n@media (max-width: 830px) {\n    .mainPage-logo__container {\n        height: 90px;\n    }\n}\n@media (max-width: 767px) {\n    .mainPage-logo__container {\n        text-align: center;\n        margin-top: 1rem;\n        margin-bottom: 2rem;\n    }\n}\n\n@media (max-width: 576px) {\n    .mainPage-logoPartners__img {\n        width: 90px;\n    }\n}\n\n@media (max-width: 350px) {\n    .mainPage-logoPartners__img {\n        width: 80px;\n    }\n}\n\n/* Start - MainCard */\n\n.mainCard-container {\n    display: flex;\n    /* flex-wrap: wrap; */\n    /* justify-content: space-between; */\n}\n\n.mainCard-card {\n    padding: 0 40px;\n}\n\n.mainCard-card__container {\n    --bs-card-border-color: none;\n    --bs-card-border-radius: 0;\n\n    min-height: 350px;\n    display: flex;\n}\n\n.mainCard-card__img{\n    border-radius: 0;\n    text-align: justify;\n}\n\n.mainCard-card__text {\n    text-align: justify;\n    margin-bottom: 16px;\n}\n\n.mainCard-card__link {\n    margin-top: auto;\n    color: #000;\n    text-decoration: none;\n    cursor: default;\n}\n\n.mainCard-card__messege-container {\n    position: absolute;\n    /* top: 26%; */\n    top: 34%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    opacity: 1;\n    line-height: 24px;\n    padding: 20px;\n    background-color: #fff;\n    border-radius: 10px;\n    font-size: 20px;\n}\n\n.mainCard-card__opacity {\n    opacity: 0.4;\n}\n\n.mainCard-card__link {\n    text-transform: upperCase;\n    /* color: #2bd191be; */\n    color: var(--main-green-color);\n    text-decoration: underline;\n}\n\n.mainCard-card__link:hover {\n    cursor: pointer;\n    color: #0a58ca;\n}\n\n.mainCard-card__link:active {\n    color: #0a58ca;\n}\n\n\n/* End - MainCard */\n\n.button_img{\n    width: 5rem;\n    cursor: pointer;\n    right: 10rem; \n    position: absolute;\n    /* right: -80px; */\n    bottom: -40px;\n    transition: all 0.3s;\n}\n\n.button_img.active {\n    bottom: 80px;\n}\n\n@media (max-width: 1370px) { \n    .button_img {\n        right: 0;\n    }\n}\n\n@media (max-width: 1190px) {\n    .mainCard-card__messege-container {\n        /* top: 20%; */\n        top: 30%;\n        line-height: 20px;\n        padding: 15px;\n        background-color: #fff;\n        border-radius: 10px;\n        font-size: 16px;\n    }\n}\n\n@media (max-width: 992px) {\n    .mainCard-card__messege-container {\n        /* top: 15%; */\n        top: 25%;\n        width: 70%;\n        line-height: 16px;\n        padding: 10px;\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 767px) {\n    .main-content{\n        width: 95%;\n        padding-bottom: 55px;\n    }\n\n    .mainCard-card__container {\n        min-height: 100px;\n    }\n\n    .mainCard-card__messege-container {\n        /* top: 26%; */\n        top: 35%;\n        width: 60%;\n        line-height: 24px;\n        padding: 20px;\n        font-size: 20px;\n    }\n\n    .button_img{\n        right: 50%;\n        transform: translateX(50%);\n        /* bottom: -60px; */\n    }\n\n    .button_img.active {\n        bottom: 40px;\n    }\n}\n\n@media (max-width: 600px) {\n    .mainCard-card__messege-container {\n        top: 26%;\n        left: 50%;\n    }\n}\n\n@media (max-width: 576px) {\n    .mainCard-card__messege-container {\n        /* top: 60px; */\n        top: 90px;\n        /* top: 25%; */\n        width: 80%;\n        line-height: 16px;\n        padding: 10px;\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 400px) {\n    .mainCard-card__messege-container {\n        top: 65px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
